module.exports = __webpack_public_path__ + "img/0220809161418.30f9528f.jpg";